import { useState } from "react";
import { toast } from "sonner";
import { Droplets } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api, { formatApiError } from "@/lib/api";
import { enqueue, isOffline } from "@/lib/offline";

export default function QuickAdjustModal({ componente, onClose, onDone }) {
  const [cantidad, setCantidad] = useState("");
  const [motivo, setMotivo] = useState("Ajuste por margen técnico de preparación");
  const [saving, setSaving] = useState(false);

  if (!componente) return null;

  async function guardar(e) {
    e.preventDefault();
    const delta = parseFloat(cantidad);
    if (!delta || delta <= 0) return toast.error("Captura una cantidad válida");
    setSaving(true);
    const payload = {
      componente_id: componente.id, delta, motivo,
      tipo: "margen_tecnico", origen: "pos", offline_uuid: crypto.randomUUID(),
    };
    try {
      if (isOffline()) {
        enqueue("ajuste", payload);
        toast.success("Ajuste en cola: se sincronizará al recuperar conexión");
        onDone(componente.id, (componente.stock || 0) + delta);
      } else {
        const { data } = await api.post("/ajustes", payload);
        toast.success(`Stock actualizado: ${data.stock_nuevo} ${data.unidad}`);
        onDone(componente.id, data.stock_nuevo);
      }
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog open={!!componente} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-sm rounded-2xl" data-testid="quick-adjust-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-bold flex items-center gap-2">
            <Droplets className="w-5 h-5 text-brand-amber" /> Ajuste rápido de stock
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={guardar} className="space-y-4">
          <div className="bg-brand-amber-soft border border-brand-amber-line rounded-xl px-3 py-2">
            <div className="text-sm font-semibold text-brand-ink">{componente.nombre}</div>
            <div className="text-xs text-brand-amber-dark font-mono">Stock actual: {componente.stock} {componente.unidad}</div>
          </div>
          <div>
            <label className="eyebrow">Cantidad a agregar ({componente.unidad})</label>
            <input data-testid="quick-adjust-quantity" type="number" min="0" step="0.001" value={cantidad} onChange={(e) => setCantidad(e.target.value)} className="field h-11 mt-1 font-mono" autoFocus required />
          </div>
          <div>
            <label className="eyebrow">Motivo (trazabilidad)</label>
            <input data-testid="quick-adjust-reason" value={motivo} onChange={(e) => setMotivo(e.target.value)} className="field h-11 mt-1" required />
          </div>
          <p className="text-xs text-brand-muted">El ajuste queda registrado con tu usuario, fecha y hora, separado de las mermas.</p>
          <button data-testid="quick-adjust-submit" type="submit" disabled={saving} className="btn-amber w-full h-11">
            {saving ? "Guardando…" : "Aplicar ajuste"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
